import { useQuery } from "@tanstack/react-query";
import { getZones } from "../../service/query/auth";

export const useGetZones = (id) => {
  const zones = useQuery({
    queryKey:["get_all_zones", id],
    queryFn:async()=> getZones({id}),
    enabled: !!id,
    staleTime: 0,


  },
  
);
  return {data:zones?.data?.data,  ...zones,}
};